import React from 'react'
import { Theme } from 'src/styles/Theme'
import { StyledIconBase } from '@styled-icons/styled-icon'
import styled from 'styled-components'
import { IconName, StyledIcon } from 'src/components/atoms/StyledIcon'

export const IconStyleWrapper = styled.i`
  ${StyledIconBase} {
    display: inline-block;
    position: relative;
    font-weight: 400;
    text-align: center;
    vertical-align: text-bottom;
    -webkit-user-select: none;
    user-select: none;
  }
`

type IconProps = {
  /**
   * アイコンの名前
   */
  name: IconName
  /**
   * アイコンの色
   */
  color?: keyof Theme['iconColors']
  /**
   * サイズは px で指定します。
   */
  size?: string
  /**
   * disabled フラグ
   */
  disabled?: boolean
  /**
   * loading フラグ
   */
  isLoading?: boolean
} & React.ButtonHTMLAttributes<SVGSVGElement>

/**
 * 通常のアイコン
 */
export const Icon: React.VFC<IconProps> = ({ size = '16px', name, ...props }) => {
  return (
    <IconStyleWrapper>
      <StyledIcon {...{ ...props, name, size }} />
    </IconStyleWrapper>
  )
}
